export const SET_ADMINS = "SET_ADMINS";
export const CLEAR_ADMINS = "CLEAR_ADMINS";
export const SET_CURRENT_ADMIN = "SET_CURRENT_ADMIN";
export const CLEAR_CURRENT_ADMIN = "CLEAR_CURRENT_ADMIN";
